import React from 'react'
import c from 'classnames'

import * as F from 'discada/dist/Form'
import { initialFee } from 'reducers/quoteReducers'

import Collection from 'components/widgets/Collection'

export function Fee({ item, editValue, index }) {
  return (
    <div className="quote-config-collection-leaseTerm">
      <F.TextField
        size="small"
        // label="Description"
        value={item.description}
        onChange={({ target }) => editValue(index, 'description', target.value)}
      />
      <F.TextField
        size="small"
        type="number"
        value={item.value}
        onChange={({ target }) =>
          editValue(index, 'value', parseFloat(target.value))
        }
      />
      <F.CheckboxField
        size="small"
        checked={item.loan}
        onChange={e => editValue(index, 'loan', e.target.checked)}
      />
      <F.CheckboxField
        size="small"
        checked={item.lease}
        onChange={e => editValue(index, 'lease', e.target.checked)}
      />
      <F.CheckboxField
        size="small"
        checked={item.taxable}
        onChange={e => editValue(index, 'taxable', e.target.checked)}
      />
      <F.CheckboxField
        size="small"
        checked={item.inCap}
        onChange={e => editValue(index, 'inCap', e.target.checked)}
      />
      <F.CheckboxField
        size="small"
        checked={item.taxInCap}
        onChange={e => editValue(index, 'taxInCap', e.target.checked)}
      />
    </div>
  )
}

export default function Fees({
  items,
  addItem,
  removeItem,
  editValue,
  hideTitle,
  hideHelp,
}) {
  return (
    <section className="quote-fees">
      {!hideTitle && <h3>Fees</h3>}
      {!hideHelp && (
        <article className="message is-info is-small">
          <div className="message-body">
            These fees are what your rooftop charges for the sale of a car, for
            example your Doc Fee, as well as any State Registration Fees. They
            will be included by default in all of your quotes. You can use the
            checkboxes to set tax settings for a given fee in the case of a
            lease quote.
          </div>
        </article>
      )}
      {['fees'].map(s => (
        <Collection
          key={s}
          headers={[
            'Description',
            'Amount',
            'Apply to Loans',
            'Apply to Leases',
            'Taxable?',
            'Capitalize',
            'Tax in the Cap?',
          ]}
          className={c(
            'quote-config-collection',
            `quote-config-collection-${s}`,
          )}
          items={items}
          addItem={addItem(s, {
            ...initialFee,
          })}
          removeItem={removeItem(s)}
          itemRenderer={(item, index, items) => (
            <Fee {...{ item, index, items }} editValue={editValue(s)} />
          )}
        />
      ))}
    </section>
  )
}
